import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CommonService } from "@app/core/http/common.service";
import { AnswerService } from "@app/core/services/answer.service";
import {
  CountdownComponent,
  CountdownConfig,
  CountdownEvent,
} from "ngx-countdown";
declare var $: any;

@Component({
  selector: "header-evaluate-menu",
  templateUrl: "./header-evaluate-menu.component.html",
  styleUrls: ["./header-evaluate-menu.component.css"],
})
export class HeaderEvaluateMenuComponent implements OnInit {
  @Input() questionCode: string;
  @Input() question: {};
  @Input() timmer: number;
  @Input() autoTimer: boolean = false;
  @Output() autoSubmitEvent: any = new EventEmitter<any>();

  @Output() timerEvent: any = new EventEmitter<any>();

  public duration: number;

  public isTimmerShow: boolean = false;

  public config: CountdownConfig = {
    leftTime: 0,
    notify: [30],
    format: "mm:ss",
    demand: false,
  };

  @ViewChild("countdown", { static: false })
  private countdown: CountdownComponent;

  public questionName: string;

  constructor(private _cservice: CommonService) {}

  ngOnInit() {}

  handleEvent(e: CountdownEvent) {
    console.log("handle event");
    if (e.action === "notify") {
      console.log("Notify");
      $(".timmer-text").css("color", "red");
    } else if (e.action === "done") {
      console.log("done");
      // if (this.timmer) this.timerEvent.emit(e);
      if (this.autoTimer) {
        if (this.questionCode == "W001" || this.questionCode == "W002") {
          this.autoSubmitEvent.emit();
        }
      }
    }
  }

  ngOnChanges(changes): void {
    console.log(changes);
    if (changes.question) {
      if (changes.question.currentValue.duration) {
        this.timmer = changes.question.currentValue.duration;
        console.log(this.timmer);
        if (changes.question.firstChange == false) {
          this.isTimmerShow = false;
          this.config.leftTime = this.timmer;
          this.countdown.restart();
          setTimeout(() => {
            this.isTimmerShow = true;
          }, 300);
        } else if (changes.question.firstChange == true) {
          this.isTimmerShow = true;
          this.config.leftTime = this.timmer;
        }
      } else this.isTimmerShow = false;
    } else if (changes.timmer) {
      if (changes.timmer.currentValue) {
        if (changes.timmer.firstChange == false) {
          this.isTimmerShow = false;
          this.config.leftTime = changes.timmer.currentValue;
          this.countdown.restart();
          setTimeout(() => {
            this.isTimmerShow = true;
          }, 300);
        } else if (changes.timmer.firstChange == true) {
          this.isTimmerShow = true;
          this.config.leftTime = this.timmer;
        }
      } else this.isTimmerShow = false;
    }

    this.questionName = this._cservice.getquestionName(this.questionCode);
  }
}
